import { ColumnMetadata, ColumnTypes } from "~/components/DataGrid";
import { AssetColumns } from "~/modules/assets/types";
import { AssetTableRowData } from "../types";
import { CatalogReferenceDataSlugs } from "~/modules/catalog/types";

// // // //

export const INCEPTION_DATE_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: "inception_date",
    label: "Inception Date",
    tooltip: CatalogReferenceDataSlugs.inception_date,
    type: ColumnTypes.date,
    width: 160,
    cellValue: (item) => {
        if (item.isAsset) {
            const inception_date = item.inception_date as string | null;
            return inception_date;
        }

        return null;
    },
};
